export default "__VITE_ASSET__DIAHi0hc__"